import { useCallback } from 'react';
import { captureException } from '../utils/sentryUtils';
import { assertChirpMutationReady } from '../utils/chirpMutationGuards';
import { chirpApprovalToApprovalData } from '../utils/chirpApprovalAdapters';
import { useRejectApprovalMutation } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.hooks';
import { GET_LATEST_APPROVAL_QUERY } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.dfc.new';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from '../constants/approvalTypeIds';
export const useRejectApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  usersRecord,
  resolvedData
}) => {
  const [chirpRejectApproval] = useRejectApprovalMutation();
  const reject = useCallback(note => {
    const validated = assertChirpMutationReady('useRejectApproval', resolvedData, approvableObjectId);
    return chirpRejectApproval({
      variables: {
        approvalId: validated.resolvedData.id,
        rejectionNote: note
      },
      update: (cache, {
        data: mutationData
      }) => {
        var _mutationData$result;
        const approvalData = mutationData === null || mutationData === void 0 || (_mutationData$result = mutationData.result) === null || _mutationData$result === void 0 ? void 0 : _mutationData$result.approval;
        if (approvalData) {
          cache.writeQuery({
            query: GET_LATEST_APPROVAL_QUERY,
            variables: {
              approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
              approvalAction,
              approvableObjectId: validated.approvableObjectId
            },
            data: {
              result: {
                approval: approvalData
              }
            }
          });
        }
      }
    }).then(result => {
      var _result$data;
      const approval = result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.result) === null || _result$data === void 0 ? void 0 : _result$data.approval;
      if (approval) {
        return chirpApprovalToApprovalData(approval, usersRecord, approvalType, approvalAction);
      } else {
        throw new Error('CHIRP rejectApproval succeeded but returned no approval data');
      }
    }).catch(error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalData-reject-chirp',
          approvalType,
          approvalAction,
          approvalId: validated.resolvedData.id
        }
      });
      throw error;
    });
  }, [chirpRejectApproval, resolvedData, usersRecord, approvalType, approvalAction, approvableObjectId]);
  return reject;
};